import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TemplateFormat } from './symbols';

@Injectable()
export class PdfTemplatesService {
  private apiUrl = '/api/pdf-generator/generate';

  constructor(private http: HttpClient) {
  }

  generatePdf(html: string, data: any, format: TemplateFormat, css: string): Observable<string> {
    const payload = { template: html, data, width: format.width, height: format.height, css };

    return this.http.post(`${this.apiUrl}/`, payload, { responseType: 'blob' })
      .pipe(
        map(blob => {
          return URL.createObjectURL(blob);
        })
      );
  }


  getTemplateFormatList(): Observable<TemplateFormat[]> {
    return this.http.get<TemplateFormat[]>('/api/template-formats');
  }
}
